import { styled } from '@mui/material/styles';

const PREFIX = 'SelectionActionsBar';

export const classes = {
  root: `${PREFIX}-root`,
  summary: `${PREFIX}-summary`,
  report: `${PREFIX}-report`,
  divider: `${PREFIX}-divider`,
};

// Same height, padding and border family as SelectionSummaryBar so the two sit side by side.
export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: theme.spacing(1),
    fontFamily: 'Roboto Condensed, Roboto, sans-serif',
    fontSize: '0.8125rem',
    lineHeight: 1,
    height: theme.spacing(4),
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: `0 ${theme.spacing(1.5)}`,
    marginLeft: theme.spacing(1),
    zIndex: 1,
  },

  [`& .${classes.summary}`]: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
  },

  [`& .${classes.report}`]: {
    fontWeight: 500,
    color: theme.palette.success.main,
    whiteSpace: 'nowrap',
  },

  [`& .${classes.divider}`]: {
    color: theme.palette.grey[300],
    userSelect: 'none',
  },
}));
